import styled from 'styled-components';

export const Stats = styled.section`
  padding: ${({ isHome }) => (isHome ? '170px 0 150px' : '120px 0')};

  .statistic-number h4,
  .statistic-description p {
    color: ${({ dark, theme: { colors } }) =>
      dark ? colors.darkGrey : colors.white};
  }

  .statistic-number h4 {
    font-size: 85px;
    font-weight: bold;
    letter-spacing: -0.63px;
    line-height: 78px;
    margin: 0;

    @media only screen and (max-width: 767px) {
      font-size: 70px;
    }
  }

  .statistic-description p {
    font-size: 20px;
    letter-spacing: 0.57px;
    line-height: 29px;
    margin: 0 0 0 20px;

    @media only screen and (max-width: 767px) {
      margin: 0;
    }
  }

  @media only screen and (max-width: 979px) {
    padding: 100px 0;
    text-align: center;

    .statistic-number {
      width: 100%;
    }

    .statistic-description {
      width: 100%;
    }
  }

  @media only screen and (max-width: 767px) {
    flex-wrap: wrap;
    padding: ${({ isHome }) => (isHome ? '40px 0' : '70px 0 30px')};
  }

  ${({ customCSS }) => customCSS}
`;
